import useDidMount from './useDidMount';

import { scrollToNode } from '../utils/dom';
import { getSectionId } from '../utils/getters';

export const useScrollToSelectedElement = (selectedElement) => {
  useDidMount(() => {
    scrollToNode(`#${getSectionId(selectedElement)}`);
  }, [selectedElement]);

  return;
};
